
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  FreelancerVerticalStateResource,
  ReasonForRequest,
  SimpleError,
  StrategyRefusalRequest,
  ValidationError,
} from '../models';
import {
    FreelancerVerticalStateResourceFromJSON,
    FreelancerVerticalStateResourceToJSON,
    ReasonForRequestFromJSON,
    ReasonForRequestToJSON,
    SimpleErrorFromJSON,
    SimpleErrorToJSON,
    StrategyRefusalRequestFromJSON,
    StrategyRefusalRequestToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface AcceptToRegularRequest {
    profileId: string;
    reasonForRequest: ReasonForRequest;
}

export interface AcceptToStrategyRequest {
    profileId: string;
}

export interface GetByIdRequest {
    profileId: string;
}

export interface RefuseSilentlyToStrategyRequest {
    profileId: string;
}

export interface RefuseToStrategyRequest {
    profileId: string;
    strategyRefusalRequest: StrategyRefusalRequest;
}

export interface SuggestToStrategyRequest {
    profileId: string;
    reasonForRequest: ReasonForRequest;
}

/**
 * 
 */
export class FreelancerVerticalStateApi extends runtime.BaseAPI {

    /**
     * Modify the vertical for a freelancer, passing to regular. |  (No vetting step is needed for this operation) 
          */
    async acceptToRegularRaw(requestParameters: AcceptToRegularRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerVerticalStateResource>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling acceptToRegular().'
            );
        }

        if (requestParameters['reasonForRequest'] == null) {
            throw new runtime.RequiredError(
                'reasonForRequest',
                'Required parameter "reasonForRequest" was null or undefined when calling acceptToRegular().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerVerticalStateResource>({
            path: `/profile/api/profiles/{profileId}/freelancer-vertical/regular/accept`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReasonForRequestToJSON(requestParameters['reasonForRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerVerticalStateResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Modify the vertical for a freelancer, passing to regular. |  (No vetting step is needed for this operation) 
          */
    async acceptToRegular(requestParameters: AcceptToRegularRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerVerticalStateResource> {
        const response = await this.acceptToRegularRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * We accept the freelancer on the strategy vertical. 
          */
    async acceptToStrategyRaw(requestParameters: AcceptToStrategyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerVerticalStateResource>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling acceptToStrategy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerVerticalStateResource>({
            path: `/profile/api/profiles/{profileId}/freelancer-vertical/strategy/accept`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerVerticalStateResourceFromJSON(response._data); }
        return response;
    }

    /**
     * We accept the freelancer on the strategy vertical. 
          */
    async acceptToStrategy(requestParameters: AcceptToStrategyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerVerticalStateResource> {
        const response = await this.acceptToStrategyRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Returns the current freelancer vertical state
          */
    async getByIdRaw(requestParameters: GetByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerVerticalStateResource>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling getById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerVerticalStateResource>({
            path: `/profile/api/profiles/{profileId}/freelancer-vertical`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerVerticalStateResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Returns the current freelancer vertical state
          */
    async getById(requestParameters: GetByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerVerticalStateResource> {
        const response = await this.getByIdRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * On the vetting after the suggestion of a freelancer integrating the strategy vertical, | we cancel the operation (i.e. we redirect silently the freelancer to regular) 
          */
    async refuseSilentlyToStrategyRaw(requestParameters: RefuseSilentlyToStrategyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerVerticalStateResource>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling refuseSilentlyToStrategy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerVerticalStateResource>({
            path: `/profile/api/profiles/{profileId}/freelancer-vertical/strategy/refuse-silently`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerVerticalStateResourceFromJSON(response._data); }
        return response;
    }

    /**
     * On the vetting after the suggestion of a freelancer integrating the strategy vertical, | we cancel the operation (i.e. we redirect silently the freelancer to regular) 
          */
    async refuseSilentlyToStrategy(requestParameters: RefuseSilentlyToStrategyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerVerticalStateResource> {
        const response = await this.refuseSilentlyToStrategyRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * On the vetting after the suggestion of a freelancer integrating the strategy vertical, | we refuse the freelancer on the new vertical, and automatically redirect to regular. 
          */
    async refuseToStrategyRaw(requestParameters: RefuseToStrategyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerVerticalStateResource>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling refuseToStrategy().'
            );
        }

        if (requestParameters['strategyRefusalRequest'] == null) {
            throw new runtime.RequiredError(
                'strategyRefusalRequest',
                'Required parameter "strategyRefusalRequest" was null or undefined when calling refuseToStrategy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerVerticalStateResource>({
            path: `/profile/api/profiles/{profileId}/freelancer-vertical/strategy/refuse`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StrategyRefusalRequestToJSON(requestParameters['strategyRefusalRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerVerticalStateResourceFromJSON(response._data); }
        return response;
    }

    /**
     * On the vetting after the suggestion of a freelancer integrating the strategy vertical, | we refuse the freelancer on the new vertical, and automatically redirect to regular. 
          */
    async refuseToStrategy(requestParameters: RefuseToStrategyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerVerticalStateResource> {
        const response = await this.refuseToStrategyRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Suggest the modification of vertical for a freelancer, passing to strategy. |  A vetting step is needed to confirm the modification (see other endpoints) 
          */
    async suggestToStrategyRaw(requestParameters: SuggestToStrategyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerVerticalStateResource>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling suggestToStrategy().'
            );
        }

        if (requestParameters['reasonForRequest'] == null) {
            throw new runtime.RequiredError(
                'reasonForRequest',
                'Required parameter "reasonForRequest" was null or undefined when calling suggestToStrategy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancerVerticalStateResource>({
            path: `/profile/api/profiles/{profileId}/freelancer-vertical/strategy/apply`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReasonForRequestToJSON(requestParameters['reasonForRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancerVerticalStateResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Suggest the modification of vertical for a freelancer, passing to strategy. |  A vetting step is needed to confirm the modification (see other endpoints) 
          */
    async suggestToStrategy(requestParameters: SuggestToStrategyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerVerticalStateResource> {
        const response = await this.suggestToStrategyRaw(requestParameters, initOverrides);
        return response._data;
    }

}
